module.exports = __webpack_public_path__ + "img/1728543411899-Screenshot_10-10-2024_145634_www.instagram.com.jpeg.d207d096.webp";